import React, { useState }  from 'react'
import { Person, Image, CheckLg, Plus, Envelope, Telephone, ChatLeftDots, Pen } from "react-bootstrap-icons"
import FileDropzone from '../../../FormComponents/FileDropzone'
import { Field } from 'formik'
import NewClientAddContact from './NewClientAddContact'


export default function NewClientSecondPage({
  setFieldValue,
  values,
  currentPage,
  setCurrentPage,
  clientContacts,
  setClientContacts,
 }) {

  const [src, setSrc] = useState(values.image)
  const [showAddContact, setShowAddContact] = useState(false)
  const [editableContact, setEditableContact] = useState()
  const [edit, setEdit] = useState(false)
  const [index, setIndex] = useState()
  const addToClientContacts = newClient => setClientContacts([...clientContacts, newClient])
  const updateClientContacts = (updatedContact, index) => {
    const newClientContactsList = clientContacts.map((contact, i) => i === index ? updatedContact : contact)
    setClientContacts(newClientContactsList)
    setEditableContact(null)
    setEdit(false)
  }
  const deleteClientContact = (index) => {
    const newClientContactsList = clientContacts.filter((_, i) => i !== index)
    setClientContacts(newClientContactsList)
    setEditableContact(null)
    setEdit(false)
  }

  const themeColors = [
    '#E54747',
    '#E59D47',
    '#E9E12F',
    '#A0E547',
    '#47E590',
    '#47E5E5',
    '#6747E5',
    '#BC47E5',
    '#E547A6'
  ]

  return (
    showAddContact ? (
      <NewClientAddContact
        edit={edit}
        editableContact={editableContact}
        index={index}
        addToClientContacts={addToClientContacts}
        updateClientContacts={updateClientContacts}
        deleteClientContact={deleteClientContact}
        setShowAddContact={setShowAddContact}
      />
    ) : (
      <div>
        <div className="mb-5">
          <div className="flex justify-between items-center">
            <p className="font-bold text-md ">Client contacts</p>
            <button
              type="button"
              className="flex items-center bg-rb-green text-white p-1 px-3 rounded-md"
              onClick={() => setShowAddContact(true)}
            >
              <Plus />Add new
            </button>
          </div>

          <div className="overflow-y-scroll">
            {clientContacts.map((clientContact, index) => (
              <div key={index} className="grid grid-cols-12 my-4 items-center border-1 border-rb-widget-boarder rounded-lg p-3">
                <div className="col-span-1">
                  {clientContact.avatar && <img className="h-12 w-12 rounded-2xl" src={URL.createObjectURL(clientContact.avatar)} /> || <div className="h-12 w-12 bg-rb-green rounded-2xl text-white flex items-center justify-center border-1 border-white"><Person /></div>}
                </div>
                <div className="pl-4 col-span-10">
                  <p className="text-sm font-bold">{clientContact.name}</p>
                  <div className="flex items-center">
                    <p className="text-sm flex items-center mr-4"> <span className="text-rb-green mr-1"><Envelope /></span> <span>{clientContact.email}</span></p>
                    <p className="text-sm flex items-center mr-4"><span className="text-rb-green mr-1"><Telephone /></span><span>{clientContact.phone}</span></p>
                    {clientContact.notes && (
                      <ChatLeftDots className='text-rb-green'/>
                    )
                    }
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    setEdit(true)
                    setIndex(index)
                    setEditableContact(clientContact)
                    setShowAddContact(true)
                  }}
                  className="col-span-1 rounded-md hover:bg-gray-200 w-10 h-10 flex items-center justify-center mr-4"
                  >
                    <Pen />
                  </button>
              </div>
            ))}
          </div>
        </div>
        <div>
          <h3 className='font-bold text-lg'>Visuals</h3>
          <p className='text-rb-mat-grey text-md'>select a color for your campaign thumbnail</p>
          <div className='flex justify-between items-center mt-5'>
            <div>
              <div className="flex px-2">
                {
                  themeColors.map((color, index) => (
                    <label
                      key={index}
                      className="cursor-pointer h-8 w-8 rounded-full border-1 border-white -ml-2 flex justify-center items-center"
                      style={{ backgroundColor: color }}
                    >
                      <Field type="radio" name="theme_color" value={color} className="hidden" />
                      {values.theme_color === color ? <CheckLg className='text-white text-xl' /> : ''}
                    </label>
                  ))
                }
              </div>
            </div>
            <div className="h-16 w-30 rounded-md p-3 flex justify-between items-center border-1 border-rb-ligher-grey">
              <div className="h-12 w-12 mr-2 rounded-md p-4 font-bold flex items-center justify-center border-1 border-rb-lighter-grey" style={{ backgroundColor: values.theme_color }}>
                <span>TP</span>
              </div>
              <p className='w-[150px] truncate font-bold'>Thumbnail preview</p>
            </div>
          </div>

          <div className='mt-5'>
            <p className='text-rb-mat-grey text-md mb-3'>or select an image</p>
            <FileDropzone
              uploadFiles={files => {
                setSrc(URL.createObjectURL(files[0]))
                setFieldValue('image', files[0])
              }}
              icon={<Image />}
              key='client_upload'
            />
            <div className={`w-full flex justify-center ${src && 'py-6' || 'py-1'}`}>
              {src && <img className="h-20 w-20 rounded-3xl" src={src} />}
            </div>
          </div>
        </div>


        <div className="flex justify-between mt-5">
          <button
            type='button'
            className='rb-btn-cancel font-bold text-md ml p-2 px-4 rounded-lg'
            onClick={() => {
              currentPage === "firstPage" ?
                setCreateClientModalOpen(false) :
                currentPage == "secondPage" ?
                  setCurrentPage('firstPage') :
                  setCurrentPage('secondPage')
            }}
          >
            {currentPage === "secondPage" ? 'Previous step' : 'Cancel'}
          </button>
          <button
            type={currentPage === "secondPage" ? "submit" : "button"}
            className="ml-auto bg-rb-green text-white rounded-lg p-2 px-4 submit text-center active:shadow-outer active:shadow-rb-green border-rb-green"
            onClick={() => setCurrentPage('secondPage')}
          >
            {currentPage === "secondPage" ? 'Create' : 'Next'}
          </button>
        </div>
      </div>
    )
  )
}
